import { VStack, Box, Col, Row, Spinner } from "@reverb-ui/react";
import { useContext } from "react";
import { MetricCard } from "../../components/MetricCard";
import { TrafficInsightChart } from "./TrafficInsightChart";
import { TrafficInsightsContext } from "../context-api/TrafficInsightsProvider";
import { TrafficInsightsMap } from "./TrafficInsightsMap";
import { TopLocations } from "./TopLocations";
import { IconVariationEnum } from "data/constants/constants";
import { ListCardSkeleton } from "presentation/components/Skeleton/CardSkeleton";
import { TopFiveSkeleton } from "presentation/components/Skeleton/TopFiveSkeleton";
import { panelsInfo } from "helper/panelsHelper";
import PanelContainer from "presentation/components/PanelContainer";

const insightsOnTrafficInfo = panelsInfo.insightsOnTraffic;

export const TrafficInsightsReports = () => {
  const {
    requestParamsIndex,
    insightsOnTrafficData,
    countryTrafficRanking,
    downloadingReports,
    downloadInsightsOnTrafficCSV,
    isLoadingTraffic,
    isLoadingGeo,
    mapProps,
    chartProps,
  } = useContext(TrafficInsightsContext);
  return (
    <PanelContainer
      panelId={insightsOnTrafficInfo.htmlId}
      panelName={insightsOnTrafficInfo.description}
      rangeName={insightsOnTrafficData?.range}
      isLoading={isLoadingGeo || isLoadingTraffic}
      downloadOptions={{
        onClickGenerateCSV: downloadInsightsOnTrafficCSV,
        downloadingReports: downloadingReports,
        panelInfo: insightsOnTrafficInfo,
        filterStateIndex: requestParamsIndex,
      }}
      printBreakClass={false}
    >
      <Row>
        <Col
          col={
            !isLoadingTraffic && insightsOnTrafficData?.cards.length === 0
              ? 0
              : 3
          }
        >
          {isLoadingTraffic ? (
            <ListCardSkeleton
              numberOfCards={3}
              spacingBetween={5}
              hasVariationPeriod={true}
            />
          ) : (
            <VStack w="full" spacing={5}>
              {insightsOnTrafficData?.cards.map((item, index) => (
                <MetricCard
                  key={index}
                  order={item.order}
                  iconName={item.iconTitle}
                  title={item.title}
                  description={item.text}
                  variation={item.percentageVariation}
                  variationPeriod={item.previousRange}
                  variationType={item.iconVariation as IconVariationEnum}
                  negativeMetric={item.title === "SPIKES ON BOUNCE"}
                />
              ))}
            </VStack>
          )}
        </Col>
        <Col
          col={
            !isLoadingTraffic && insightsOnTrafficData?.cards.length === 0
              ? 12
              : 9
          }
        >
          <Box
            w="full"
            h="647px"
            id="traffic-chart-container"
            className="container-print-break"
          >
            {isLoadingTraffic ? (
              <Box
                w="full"
                h="full"
                bg="white"
                display="flex"
                justifyContent="center"
              >
                <Spinner
                  size="lg"
                  color="blue.500"
                  marginTop="auto"
                  marginBottom="auto"
                  padding="5%"
                />
              </Box>
            ) : (
              insightsOnTrafficData && (
                <TrafficInsightChart
                  chartData={insightsOnTrafficData.trafficDataChart}
                  chatProps={chartProps}
                />
              )
            )}
          </Box>
        </Col>
      </Row>
      <Row pt={3}>
        <Col col={9} h="420px">
          <Box w="full" h="full" className="container-print-break">
            {isLoadingGeo ? (
              <Box
                w="full"
                h="full"
                bg="white"
                display="flex"
                justifyContent="center"
              >
                <Spinner
                  size="lg"
                  color="blue.500"
                  marginTop="auto"
                  marginBottom="auto"
                  padding="5%"
                />
              </Box>
            ) : (
              countryTrafficRanking && (
                <TrafficInsightsMap
                  geolocations={countryTrafficRanking.geolocations}
                  mapProps={mapProps}
                />
              )
            )}
          </Box>
        </Col>
        <Col col={3} id="col-top-locations">
          <Box
            w="full"
            h={{ "desktop-lg": "400px" }}
            className="container-print-break"
          >
            {isLoadingGeo ? (
              <TopFiveSkeleton />
            ) : (
              countryTrafficRanking && (
                <TopLocations
                  topGeolocations={countryTrafficRanking.topGeolocations}
                  isLoading={isLoadingTraffic}
                />
              )
            )}
          </Box>
        </Col>
      </Row>
    </PanelContainer>
  );
};
